<template>
  <v-row class="ma-0" >
    <v-col align="center" style="width: 490px;font-size: 13px">
      <v-card class="new-card pa-10 elevation-10" align="left">
        <div class="text-center mb-4">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <div class="top-notice mb-6">
          <p class="mb-1">※都道府県名や市区町村、学校名をご入力いただくと、候補が表示されます。</p>
          <p class="mb-0">※海外の日本人学校にご勤務されている場合は、都道府県に「海外」と入力し、市区町村から国・地域名をご選択ください。</p>
        </div>
        <v-section-panel class="mb-6">
          <template v-slot:title> 1.都道府県、市区町村、学校を選択してください</template>
          <template v-slot:content>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="prefectureCode"
                  :items="prefectures"
                  item-text="name"
                  item-value="code"
                  label="都道府県"
                  no-data-text="該当する都道府県がありません"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="cityId"
                  :items="filterCities"
                  item-text="name"
                  item-value="id"
                  @change="onChangeCity"
                  label="市区町村"
                  no-data-text="該当する市区町村がありません"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="schoolId"
                  :items="schools"
                  item-text="name"
                  item-value="id"
                  :disabled="!cityId"
                  label="中学校"
                  @change="onChangeSchool"
                  no-data-text="該当する中学校がありません"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </template>
        </v-section-panel>
        <v-row>
          <v-col cols="12">
            <v-section-panel class="mb-6">
              <template v-slot:title> 2.教科を選択してください。</template>
              <template v-slot:content>
                <v-subject-button v-for='subject in subjects'
                  :key="subject.id"
                  :type="subject.code"
                  :active="subjectIds.includes(subject.id)"
                  :disabled="!subjectIds.includes(subject.id) && !otameshi"
                  @click="setSubjectIds(subject.id)"
                >
                  {{subject.name}}
                </v-subject-button>
              </template>
            </v-section-panel>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-section-panel class="mb-6">
              <template v-slot:title> 3.学年を選択してください。</template>
              <template v-slot:content>
                <div v-if="gradeIds.length || otameshi" class="d-flex" style="gap: 17px;">
                  <v-checkbox
                    v-for="(grade) in grades"
                    :key="grade.id"
                    v-model="gradeIds"
                    :label="grade.name"
                    :value="grade.id"
                    color="secondary"
                    :disabled="!otameshi"
                  />
                </div>
                <div v-if="subjectOptionIds.length" class="d-flex" style="gap: 17px;">
                  <v-checkbox
                    v-for="(shakaiOption) in shakaiOptions"
                    :key="shakaiOption.id"
                    v-model="subjectOptionIds"
                    :label="shakaiOption.name"
                    :value="shakaiOption.id"
                    color="secondary"
                    disabled
                  />
                </div>
              </template>
            </v-section-panel>
          </v-col>
        </v-row>
        <!-- おためしは先生名不要のため入力欄ごと非表示 -->
        <v-row v-if="!otameshi">
          <v-col cols="12">
            <v-section-panel class="mb-6">
              <template v-slot:title> 4.先生のお名前をご入力ください</template>
              <template v-slot:content>
                <v-text-field
                  v-model="accountName"
                  label="先生名"
                  :counter="10"
                ></v-text-field>
              </template>
            </v-section-panel>
          </v-col>
        </v-row>
        <!-- おためしはメールアドレス不要のため入力欄ごと非表示 -->
        <v-row v-if="!otameshi">
          <v-col cols="12">
            <v-section-panel class="mb-1">
              <template v-slot:title> 5.メールアドレスをご入力ください </template>
              <template v-slot:content>
                <p class="field-notice mb-1">※メールアドレスのご入力は必須ではありませんが、アカウント情報が記載されたメールが届きませんので、登録完了画面で必ずアカウント情報のメモか、データのダウンロードをお願いいたします。</p>
                <v-text-field
                  v-model="mail"
                  label="メールアドレス"
                ></v-text-field>
              </template>
            </v-section-panel>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mb-6">
            <p class="agreement-text">
              ※入力いただいた個人情報は、本システム以外の目的では使用いたしません。弊社個人情報保護方針は、下記HPをご確認ください。
              <br>&emsp;個人情報の取り扱い <a
                href="https://www.sing.co.jp/privacy.html"
                target="_blank"
              >
                https://www.sing.co.jp/privacy.html
              </a>
            </p>
            <v-radio-group
              v-model="agreement"
              hide-details
              row
            >
              <v-radio
                label="同意する"
                :value="true"
                color="secondary"
              />
              <v-radio
                label="同意しない"
                :value="false"
                color="secondary"
              />
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="agreement">
          <v-col cols="12">
            <p class="submit-notice mb-0">※「アカウント登録」のボタンをクリックした後に表示されるアカウントのIDとパスワードは必ずメモをお願いいたします。</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn color="secondary" dark :disabled="!agreement" @click="create">アカウント登録</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import config from '../../config'
import axios from "axios";
import VSectionPanel from '@/components/molecules/SectionPanel'
import VSubjectButton from '@/components/atoms/SubjectButton'

export default {
  components: {
    VSubjectButton,
    VSectionPanel,
  },
  computed: {
    prefectureCode: {
      get () {
        return this.$store.state.school.prefectureCode
      },
      set (value) {
        this.$store.commit('school/setPrefectureCode', {
          prefectureCode: value
        })
      }
    },
    cityId: {
      get () {
        return this.$store.state.school.cityId
      },
      set (value) {
        this.$store.commit('school/setCityId', {
          cityId: value
        })
      }
    },
    schoolId: {
      get () {
        return this.$store.state.school.id
      },
      set (value) {
        this.$store.commit('school/setId', {
          id: value
        })
      }
    },
    accountName: {
      get () {
        return this.$store.state.school.accountName
      },
      set (value) {
        this.$store.commit('school/setAccountName', {
          accountName: value
        })
      }
    },
    mail: {
      get () {
        return this.$store.state.school.mail
      },
      set (value) {
        this.$store.commit('school/setMail', {
          mail: value
        })
      }
    },
    gradeIds: {
      get () {
        return this.$store.state.school.gradeIds
      },
      set (value) {
        this.$store.commit('school/setGradeIds', {
          gradeIds: value
        })
      }
    },
    subjectIds: {
      get () {
        return this.$store.state.school.subjectIds
      },
      set (value) {
        this.$store.commit('school/setSubjectIds', {
          subjectIds: value
        })
      }
    },
    subjectOptionIds: {
      get () {
        return this.$store.state.school.subjectOptionIds
      },
      set (value) {
        this.$store.commit('school/setSubjectOptionIds', {
          subjectOptionIds: value
        })
      }
    },
    filterCities() {
      return this.cities.filter(city => city.prefecture_code == this.prefectureCode)
    },
    filterSchools() {
      return this.schools.filter(school => school.city_id == this.cityId)
    },
    otameshi() {
      return this.$store.state.school.materialPasswords.some(materialPassword => materialPassword === config.otameshiMaterialPassword)
    },
  },
  data () {
    return {
      allSubjects: [],
      subjects: [],
      grades: [],
      prefectures: [],
      cities: [],
      schools: [],
      shakaiOptions: [],
      agreement: null
    }
  },
  async created() {
    // 認証がまだの場合は戻す（おためしフローは/otameshiへ戻す）
    const authenticated = this.$store.state.school.materialPasswords.some(password => password !== '')
    if (!authenticated) {
      this.$router.push(this.$store.state.school.isOtameshiFlow ? '/otameshi' : '/enrollment/auth')
      return
    }
    // マスタデータ取得
    await axios.all([
      this.$axios.get('/api/v1/prefectures'),
      // 学校マスタに学校が登録されている市区町村のみ表示する
      this.$axios.get('/api/v1/cities?only_with_school_master=true'),
      this.$axios.get('/api/v1/subjects'),
      this.$axios.get('/api/v1/grades'),
    ]).then(axios.spread((res1, res2, res3, res4) => {
      this.prefectures = res1.data
      this.cities = res2.data
      this.allSubjects = res3.data
      this.subjects = res3.data.filter(subject => {
        return subject.ancestry === null
      })
      this.grades = res4.data

      // 社会の全ての分野を追加するかどうかのフラグ
      const isShakaiAllSubjectOption = this.$store.state.school.subjectGradeKeys.some(key => key.includes(config.subjects.SHAKAI))

      // 【担当教科】 編集の場合は保持した値をセット
      const selectSubjectCodes = this.$store.state.school.subjectGradeKeys.map(key => key.split('_')[0])
      this.shakaiOptions = res3.data.filter(subject => Object.values(config.shakaiOptionSubjects).includes(subject.code))
      let shakaiOptionCodes = []
      if (isShakaiAllSubjectOption) {
        shakaiOptionCodes = Object.values(config.shakaiOptionSubjects)
      } else {
        shakaiOptionCodes = selectSubjectCodes.filter(code => Object.values(config.shakaiOptionSubjects).includes(code))
      }
      const selectGradeCodes = this.$store.state.school.subjectGradeKeys.map(key => key.split('_')[1]).filter(Boolean)
      // 社会の分野選択
      if (shakaiOptionCodes.length > 0) {
        shakaiOptionCodes.push(config.subjects['SHAKAI'])
        if (isShakaiAllSubjectOption) {
          selectGradeCodes.forEach(() => {
            this.subjectOptionIds = [
              ...this.subjectOptionIds,
              ...shakaiOptionCodes.map(code => this.findSubjectId(code))
            ]
            this.subjectOptionIds = this.subjectOptionIds.filter(Boolean)
          })
        } else {
          selectGradeCodes.forEach(gradeCode => {
            if (config.specialSubjectMap['sh'][gradeCode]) {
              this.subjectOptionIds = [
                ...this.subjectOptionIds,
                ...config.specialSubjectMap['sh'][gradeCode].map(code => this.findSubjectId(code))
              ]
              this.subjectOptionIds = this.subjectOptionIds.filter(Boolean)
            }
          })
        }
      }

      this.subjectIds = selectSubjectCodes
        .filter(code => !Object.values(config.shakaiOptionSubjects).includes(code))
        .map(code => {
          return this.subjects.find(subject => subject.code === code).id
        })

      if (selectSubjectCodes.some(code => Object.values(config.shakaiOptionSubjects).includes(code))) {
        this.subjectIds =
        [...this.subjectIds, this.subjects.find(subject => subject.code === config.subjects.SHAKAI).id]
      }

      if (Object.values(this.$store.state.school.shingakuSubjectGradeKeys).flat().length > 0) {
        this.gradeIds = [1, 2, 3]
      } else {
        this.gradeIds = this.grades.filter(grade => selectGradeCodes.includes(grade.code)).map(grade => grade.id)
      }
      this.shakaiOptions.filter(subject => selectSubjectCodes.includes(subject.code)).map(subject => subject.id)

    }))
    if (this.cityId) await this.onChangeCity()
  },
  methods: {
    async onChangeSchool() {
      const school = this.schools.find(school => school.id === this.schoolId)
      this.$store.commit('school/setCode', {
        code: school.code
      })
    },
    async onChangeCity() {
      const res = await this.$axios.get(`/api/v1/school_masters?q[city_id_eq]=${this.cityId}`)
      this.schools = res.data
    },
    setSubjectIds(subjectId) {
      if (!this.otameshi) return

      if (this.otameshi && this.subjectIds.length !== 0) {
        this.subjectIds = []
      }

      if (this.subjectIds.includes(subjectId)) {
        this.subjectIds = this.subjectIds.filter(id => id !== subjectId)
      } else {
        const subjectIds = this.subjectIds.concat([subjectId])
        this.subjectIds = subjectIds
      }
    },
    async create() {
      const res1 = await this.$store.dispatch('school/temporaryValidation')
      if (res1.status === 'error')
        return this.$toasted.global.error({ message: res1.message })

      this.$app.$refs.loading.open({message: '処理中です。少々お待ちください。'})

      let uniqueSubjectTeachers = []
      if (this.otameshi) {
        this.gradeIds.forEach(gradeId => {
          const subjectOptionCodes = config.specialSubjectMap['sh'][`t${gradeId}`]
          const subjectOptionIds = subjectOptionCodes.map(code => this.findSubjectId(code))
          uniqueSubjectTeachers.push(
            {
              grade_id: gradeId,
              subject_id: this.subjectIds[0],
              subject_option_ids: this.subjectIds[0] === 5 ? subjectOptionIds : [],
              is_shingaku: false,
              is_otameshi: true,
            })
        })
      } else {
        uniqueSubjectTeachers = this.needMaterialPasswordSubjectTeachers()
      }

      // 仮登録と承認を同時に行う
      await this.$axios.post(`/api/v1/schools/create_temporary`, {
        school_master_id: this.schoolId,
        grade_ids: this.gradeIds.join(','),
        subject_ids: this.subjectIds.filter(Boolean).join(','),
        subject_option_ids: this.subjectOptionIds.filter(Boolean).join(','),
        prefecture_code: this.prefectureCode,
        city_id: this.cityId,
        account_name: this.accountName,
        mail: this.mail,
        material: this.$store.state.school.materialPasswords.filter(Boolean).join(','),
        subject_teachers: uniqueSubjectTeachers,
      }).then(res => {
        this.$app.$refs.loading.close()
        this.$store.commit('school/initialize')
        this.$store.commit('school/setRegisteredUsers', {
          registeredUsers: res.data.users,
          schoolId: res.data.id
        })
        this.$router.push('/enrollment/complete')
      })
      .catch(() => {
        this.$app.$refs.loading.close()
      })
    },
    needMaterialPasswordSubjectTeachers() {
      const subjectTeachersAttributes = []
      const subjectGradeKeys = this.$store.state.school.subjectGradeKeys

      subjectGradeKeys.forEach(subjectGradeKey => {
        const [subjectCode, gradeCode] = subjectGradeKey.split('_')

        // subjectGradeKeyがnichijoSubjectGradeKeysとshingakuSubjectGradeKeysどちらに含まれているか（またはどちらにも含まれているか）を判定
        const isNichijo = this.$store.state.school.nichijoSubjectGradeKeys.includes(subjectGradeKey)
        const isShingaku = Object.values(this.$store.state.school.shingakuSubjectGradeKeys).flat().includes(subjectGradeKey)

        // 社会の分野以外の科目-学年の組み合わせ
        if (!Object.values(config.shakaiOptionSubjects).includes(subjectCode)) {
          const subjectId = this.findSubjectId(subjectCode)
          const gradeId = this.findGradeId(gradeCode)
          // isNichijoがtrueの場合のエントリを追加
          if (isNichijo) {
            subjectTeachersAttributes.push({
              login_id: this.generateLoginId(subjectGradeKey, true, false, false),
              grade_id: gradeId,
              subject_id: subjectId,
              subject_option_ids: [],
              is_shingaku: false,
              is_otameshi: false,
            })
          }

          // isShingakuがtrueの場合のエントリを追加
          if (isShingaku) {
            subjectTeachersAttributes.push({
              login_id: this.generateLoginId(subjectGradeKey, false, true, false),
              grade_id: gradeId,
              subject_id: subjectId,
              subject_option_ids: [],
              is_shingaku: true,
              is_otameshi: false,
            })
          }
        }

        // 社会の分野の科目-学年の組み合わせ
        Object.entries(config.specialSubjectMap).forEach(([mainSubject, gradeSubjects]) => {
          if (!gradeCode) return
          const subjectOptionCodes = gradeSubjects[gradeCode]
          const subjectId = this.findSubjectId(mainSubject)
          const gradeId = this.findGradeId(gradeCode)
          const subjectOptionIds = subjectOptionCodes.map(code => this.findSubjectId(code))
          const existing = subjectTeachersAttributes.find(item => item.grade_id === gradeId && item.subject_id === subjectId)

          if (existing) {
            existing.subject_option_ids = Array.from(new Set(existing.subject_option_ids.concat(subjectOptionIds))).filter(Boolean)
          } else {
            // isNichijoの場合のエントリを追加
            if (isNichijo && Object.values(config.shakaiOptionSubjects).includes(subjectCode)) {
              subjectTeachersAttributes.push({
                login_id: this.generateLoginId(subjectGradeKey, true, false),
                grade_id: gradeId,
                subject_id: subjectId,
                subject_option_ids: Array.from(new Set(subjectOptionIds)).filter(Boolean),
                is_shingaku: false
              })
            }

            // isShingakuの場合のエントリを追加
            if (isShingaku && Object.values(config.shakaiOptionSubjects).includes(subjectCode)) {
              subjectTeachersAttributes.push({
                login_id: this.generateLoginId(subjectGradeKey, false, true),
                grade_id: gradeId,
                subject_id: subjectId,
                subject_option_ids: Array.from(new Set(subjectOptionIds)).filter(Boolean),
                is_shingaku: true
              })
            }
          }
        })
      })

      // 重複を除去 (grade_id, subject_id, subject_option_idsでユニーク)
      const uniqueSubjectTeachers = [];
      const seenKeys = new Set();

      subjectTeachersAttributes.forEach(item => {
        if (!seenKeys.has(item.login_id)) {
          seenKeys.add(item.login_id);
          uniqueSubjectTeachers.push(item);
        }
      });

      return uniqueSubjectTeachers
    },
    findSubjectId(code) {
      const subject = this.allSubjects.find(v => v.code === code)
      if (!subject) throw new Error(`Subject not found for code: ${code}`)
      return subject.id
    },
    findGradeId(code) {
      if (!code) return null
      const grade = this.grades.find(v => v.code === code)
      if (!grade) throw new Error(`Grade not found for code: ${code}`)
      return grade.id
    },
    generateLoginId(subjectGradeKey, isNichijo, isShingaku) {
      let [subjectCode, gradeCode] = subjectGradeKey.split('_')
      if (Object.values(config.shakaiOptionSubjects).includes(subjectCode)) {
        subjectCode = 'sh'
      }
      const gradeNumber = gradeCode.match(/\d/)?.[0] || gradeCode
      if (isNichijo) {
        return `${subjectCode}${gradeNumber}-${this.$store.state.school.code}`
      } else if (isShingaku) {
        // shingakuSubjectGradeKeysから、subjectGradeKeyが含まれている年を取得
        const year = Object.keys(this.$store.state.school.shingakuSubjectGradeKeys).find(year =>
          this.$store.state.school.shingakuSubjectGradeKeys[year].includes(subjectGradeKey)
        )
        // 年が偶数の場合は'y'、奇数の場合は'x'
        const prefix = year ? (parseInt(year) % 2 === 0 ? 'y' : 'x') : ''
        return `${prefix}-${subjectCode}23-${this.$store.state.school.code}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.row
  height 100%

.logo
  margin-right 18px

.new
  &-card
    max-width 1000px

.top-notice
  font-size 13px
  color #d32f2f
  line-height 1.6

.field-notice
  font-size 13px
  color #d32f2f

.submit-notice
  font-size 14px
  color #d32f2f
  font-weight bold
</style>
